'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContextProvider = require('./ContextProvider');

var _ContextProvider2 = _interopRequireDefault(_ContextProvider);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _Listener = require('../shared/VideoStore/Listener');

var _State = require('../shared/VideoStore/State');

var _Log = require('../shared/Log.js');

var _LoggingPropType = require('../shared/LoggingPropType');

var _LoggingPropType2 = _interopRequireDefault(_LoggingPropType);

var _mousetrap = require('mousetrap');

var _mousetrap2 = _interopRequireDefault(_mousetrap);

var _Shortcuts = require('./Shortcuts');

var _toggleFullscreen = require('../store/actions/players/toggleFullscreen');

var _reactRedux = require('react-redux');

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule VideoProvider
 */

var PLAYER_ID = 0;

var VideoProvider = function (_React$Component) {
  _inherits(VideoProvider, _React$Component);

  // optionally include redux provider above this
  // component
  function VideoProvider(props, context) {
    _classCallCheck(this, VideoProvider);

    var _this = _possibleConstructorReturn(this, (VideoProvider.__proto__ || Object.getPrototypeOf(VideoProvider)).call(this, props, context));

    if (process.env.NODE_ENV !== 'production') {
      console.time('VideoChromePerfTimer');
    }
    (0, _State.resetState)();
    _this.state = {
      contextState: _State.state,
      playerId: props.playerId || PLAYER_ID++ + '-' + Date.now()
    };
    (0, _Log.setLoggingData)(_this.props.logging);
    (0, _Listener.listen)(function (contextState) {
      if (process.env.NODE_ENV !== 'production') {
        window.viState = contextState;
      }
      _this.setState({ contextState: contextState });
    });
    if (!_this.context.store) {
      _this.store = _store2.default.createReduxStore(_this.props.reducers, _this.props.middleware);
    }
    return _this;
  }

  _createClass(VideoProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _State.setState)('viNode', this.viNode);
      (0, _toggleFullscreen.setFullscreenNode)(this.state.playerId, this.viNode);

      if (!this.props.disableDefaultShortcuts) {
        this.bindShortcuts();
      }

      if (process.env.NODE_ENV !== 'production') {
        console.timeEnd('VideoChromePerfTimer');
      }
    }

    /*
     * handles new promises coming in
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.disableDefaultShortcuts !== nextProps.disableDefaultShortcuts) {
        if (nextProps.disableDefaultShortcuts) {
          this.unbindShortcuts();
        } else {
          this.bindShortcuts();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _Listener.removeFluxListener)();
      (0, _toggleFullscreen.setFullscreenNode)(this.state.playerId, undefined);
      (0, _State.generateSnapshot)();
      this.unbindShortcuts();
      _mousetrap2.default.unbind('shift+d+e');
    }
  }, {
    key: 'bindShortcuts',
    value: function bindShortcuts() {
      _mousetrap2.default.bind('space', _Shortcuts.space.bind(null, this.state.playerId));
      _mousetrap2.default.bind('up', _Shortcuts.up.bind(null, this.state.playerId));
      _mousetrap2.default.bind('down', _Shortcuts.down.bind(null, this.state.playerId));
      _mousetrap2.default.bind('left', _Shortcuts.left.bind(null, this.state.playerId));
      _mousetrap2.default.bind('right', _Shortcuts.right.bind(null, this.state.playerId));
    }
  }, {
    key: 'unbindShortcuts',
    value: function unbindShortcuts() {
      _mousetrap2.default.unbind('space');
      _mousetrap2.default.unbind('up');
      _mousetrap2.default.unbind('down');
      _mousetrap2.default.unbind('left');
      _mousetrap2.default.unbind('right');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var video = _react2.default.createElement(
        'div',
        {
          className: _style2.default.viWrapper,
          ref: function ref(node) {
            _this2.viNode = node;
          }
        },
        _react2.default.createElement(
          _ContextProvider2.default,
          _extends({}, this.props, {
            playerId: this.state.playerId,
            contextState: this.state.contextState
          }),
          this.props.children
        )
      );

      if (this.context.store) {
        return video;
      }

      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: this.store },
        video
      );
    }
  }]);

  return VideoProvider;
}(_react2.default.Component);

VideoProvider.propTypes = {
  children: _propTypes2.default.node,
  continuous: _propTypes2.default.bool,
  logging: _LoggingPropType2.default,
  muted: _propTypes2.default.bool,
  disableDefaultShortcuts: _propTypes2.default.bool,
  playerId: _propTypes2.default.string,

  middleware: _propTypes2.default.arrayOf(_propTypes2.default.func),
  reducers: _propTypes2.default.object
};
VideoProvider.contextTypes = {
  store: _propTypes2.default.object
};
VideoProvider.defaultProps = {
  continuous: false,
  muted: false,
  disableDefaultShortcuts: false
};
exports.default = VideoProvider;
module.exports = exports['default'];